module.exports = __webpack_public_path__ + "img/enBrand.7aea2f8a.png";